<div class="table_field_show">
    <div class="left_field">
        <div class="list_show_title">{{ $t('productDisplay') }}</div>
        <div class="mdc-form-field">
            <div class="mdc-radio" @click="switchFocus(true)">
                <input class="mdc-radio__native-control" type="radio" id="radio-1" name="radios" checked>
                <div class="mdc-radio__background">
                    <div class="mdc-radio__outer-circle"></div>
                    <div class="mdc-radio__inner-circle"></div>
                </div>
                <div class="mdc-radio__ripple"></div>
            </div>
            <label for="radio-1" class="list_show_field" @click="switchFocus(true)">{{ $t('mainProduct') }}</label>
            <div class="mdc-radio" @click="switchFocus(false)">
                <input class="mdc-radio__native-control" type="radio" id="radio-2" name="radios">
                <div class="mdc-radio__background">
                    <div class="mdc-radio__outer-circle"></div>
                    <div class="mdc-radio__inner-circle"></div>
                </div>
                <div class="mdc-radio__ripple"></div>
            </div>
            <label for="radio-2" class="list_show_field" @click="switchFocus(false)">{{ $t('allProduct') }}</label>
        </div>
    </div>
    <div class="count">
        <span class="deadline">
            {{ $t('jdDataAsOf') }}
            <span class="date"
                v-if="homeInfoData!=null && homeInfoData.dataTime!=null">{{dateFormat(homeInfoData.dataTime[3])}}</span>
        </span>
        <span class="deadline">
            {{ $t('tmallDataAsOf') }}
            <span class="date"
                v-if="homeInfoData!=null && homeInfoData.dataTime!=null">{{dateFormat(homeInfoData.dataTime[2])}}</span>
        </span>
        <span class="deadline">
            {{ $t('u8DataAsOf') }}
            <span class="date"
                v-if="homeInfoData!=null && homeInfoData.dataTime!=null">{{dateFormat(homeInfoData.dataTime[1])}}</span>
        </span>
    </div>
</div>
<div class="table_field">
    <table-field-show v-on:showtablefield="showTableField" :showTableFieldKeys="showTableFieldKeys" />
    <div class="aggregate">
        <span>
            <span class="red" v-if="homeInfoData != null">{{
          homeInfoData.dataTotal[2]
        }}</span><i18n-t class="name" keypath="stockStatistics">
            <template #number>
                <span class="red">14</span>
            </template>
        </i18n-t>，
            <span class="red" v-if="homeInfoData != null">{{
          homeInfoData.dataTotal[1]
        }}</span><i18n-t class="name" keypath="stockStatistics">
            <template #number>
                <span class="red">5</span>
            </template>
        </i18n-t>，
            <span class="red" v-if="homeInfoData != null">{{
          homeInfoData.dataTotal[4]
        }}</span><i18n-t class="name" keypath="stockStatisticsExceed">
            <template #number>
                <span class="red">180</span>
            </template>
        </i18n-t>
        </span>
    </div>
</div>
<div class="table_content" :style="{height: tableH + 'px',width: tableW + 'px'}">
    <div class="thead_box" id="thead_box">
        <table class="table_box1" :style="tableBox1Width">
            <thead id="thead_box1">
                <tr style="background:#eee;">
                    <th class="w40">{{ $t('id') }}</th>
                    <th class="w120">{{ $t('salesDetail') }}</th>
                    <th class="w15" v-if="showTableFieldKeys[0].isShow">{{ $t('productCode') }}</th>
                    <th class="w2" v-if="showTableFieldKeys[1].isShow">{{ $t('stockName') }}</th>
                    <th class="w2" v-if="showTableFieldKeys[2].isShow">{{ $t('prdocutModel') }}</th>
                    <th class="w2" v-if="showTableFieldKeys[3].isShow">{{ $t('productName') }}</th>
                    <th class="w120" v-if="showTableFieldKeys[4].isShow">{{ $t('productColor') }}</th>
                    <th class="w15">
                        <div class="header_wrapper">
                            <div class="header_button material-icons" id="salesGrowthFactorSort"
                                @click="sortTableList('salesGrowthFactor')">
                                south
                            </div>
                            <div class="header_lable">{{ $t('salesGrowthFactor') }}</div>
                            <div class="header_button material-icons">help_outline</div>
                            <div class="help_frame_default_size help_content" style="height: 350px;">
                                <div class="title">{{ $t('salesGrowthFactor') }}</div>
                                <div class="desc">
                                    <div class="desc_title" style="float: left;">{{ $t('calculationMethod') }}</div>
                                    <div class="content" style="text-align: left;line-height: 26px;">
                                        {{ $t('salesGrowthFactorDesc') }}
                                    </div>
                                    <div style="font-size: 13px;float: left;text-align: left;line-height: 26px;color: #666666;font-weight: normal;">{{ $t('salesGrowthFactorPositiveNumber') }}</div>
                                    <div style="font-size: 13px;float: left;text-align: left;line-height: 26px;color: #666666;font-weight: normal;">{{ $t('salesGrowthFactorNegativeNumber') }}</div>
                                </div>
                            </div>
                        </div>
                    </th>
                    <th class="w15">
                        <div class="header_wrapper">
                            <div class="header_button material-icons" id="returnRateSort"
                                @click="sortTableList('returnRate')">
                                south
                            </div>
                            <div class="header_lable">{{ $t('returnRateMonth') }}</div>
                            <div class="header_button material-icons">help_outline</div>
                            <div class="help_frame_default_size help_content" style="height: 200px;">
                                <div class="title">{{ $t('returnRateMonth') }}</div>
                                <div class="desc">
                                    <div class="desc_title" style="float: left;">{{ $t('calculationMethod') }}</div>
                                    <div class="content" style="color: #F81919;line-height: 36px;">
                                        {{ $t('returnRateFormula') }}
                                    </div>
                                    <div class="count_method" style="float: left;color: #000;">{{ $t('returnRateDesc') }}</div>
                                </div>
                            </div>
                        </div>
                    </th>
                    <th class="w15" v-if="showTableFieldKeys[5].isShow">
                        <div class="header_wrapper">
                            <div class="header_lable">{{ $t('jdStock') }}</div>
                            <div class="header_button material-icons" id="jdStorageSort"
                                @click="sortTableList('jdStorage')">
                                south
                            </div>
                        </div>
                    </th>
                    <th class="w15" v-if="showTableFieldKeys[6].isShow">
                        <div class="header_wrapper">
                            <div class="header_lable">{{ $t('tmStock') }}</div>
                            <div class="header_button material-icons" id="tMallStorageSort"
                                @click="sortTableList('tMallStorage')">
                                south
                            </div>
                        </div>
                    </th>
                    <th class="w15" v-if="showTableFieldKeys[7].isShow">
                        <div class="header_wrapper">
                            <div class="header_lable">{{ $t('u8Stock') }}</div>
                            <div class="header_button material-icons" id="u8StorageSort"
                                @click="sortTableList('u8Storage')">
                                south
                            </div>
                        </div>
                    </th>
                    <th class="w15">
                        <div class="header_wrapper">
                            <div class="header_button material-icons" id="totalStorageSort"
                                @click="sortTableList('totalStorage')">
                                south
                            </div>
                            <div class="header_lable">{{ $t('stockCount') }}</div>
                            <div class="header_button material-icons">help_outline</div>
                            <div class="help_frame_default_size help_content">
                                <div class="title">{{ $t('stockCount') }}</div>
                                <div class="desc">
                                    <div class="desc_title" style="text-align: left;">{{ $t('calculationMethod') }}</div>
                                    <div class="count_method" style="float: left;text-align: left;">
                                        {{ $t('stockCountDesc') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </th>
                    <th class="w15">
                        <div class="header_wrapper">
                            <div class="header_button material-icons" id="storageSaleDaySort"
                                @click="sortTableList('storageSaleDay')">
                                south
                            </div>
                            <div class="header_lable">{{ $t('daysInStock') }}</div>
                            <div class="header_button material-icons">help_outline</div>
                            <div class="available_days_help_size help_content" style="height: 300px;">
                                <div class="title" style="text-align: left;">{{ $t('daysInStock') }}</div>
                                <div class="desc">
                                    <div class="lable" style="text-align: left;">{{ $t('calculationMethod') }}</div>
                                    <div class="content count_method" style="text-align: left;">
                                        {{ $t('stockDaysFormula') }}
                                    </div>
                                </div>
                                <div class="desc">
                                    <div class="lable" style="text-align: left;">{{ $t('averageDailySales') }}</div>
                                    <div class="content available_days_help_content_size" style="font-size: 13px;font-weight: normal;text-align: left;">
                                        {{ $t('averageDailySalesFormula') }}
                                    </div>
                                </div>
                                <div class="desc color_example_position">
                                    <div class="lable" style="text-align: left;">{{ $t('backgroundColor') }}</div>
                                    <div class="content">
                                        <div class="color_example">
                                            <span class="color_button red">{{ $t('seriouslyOutOfStock') }}</span>
                                            <span class="text">D≤5{{ $t('day') }}</span>
                                        </div>
                                        <div class="color_example">
                                            <span class="color_button yellow">{{ $t('inventoryShortage') }}</span>
                                            <span class="text">5{{ $t('day') }}&lt;D≤14{{ $t('day') }}</span>
                                        </div>
                                        <div class="color_example">
                                            <span class="color_button green">{{ $t('notOutOfStock') }}</span>
                                            <span class="text">14{{ $t('day') }}&lt;D≤180{{ $t('day') }}</span>
                                        </div>
                                        <div class="color_example">
                                            <span class="color_button blue">{{ $t('inventoryBacklog') }}</span>
                                            <span class="text">180{{ $t('day') }}&lt;D</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="desc">
                                    <div class="content available_days_help_content_size" style="font-size: 13px;font-weight: normal;padding-left: 84px;text-align: left;">
                                        {{ $t('averageDailySalesFormula') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </th>
                    <th class="w120">
                        <div class="header_wrapper">
                            <div class="header_lable">{{ $t('jdSales') }}</div>
                            <div class="header_button material-icons" id="jdSaleSort" @click="sortTableList('jdSale')">
                                south
                            </div>
                        </div>
                    </th>
                    <th class="w120">
                        <div class="header_wrapper">
                            <div class="header_lable">{{ $t('tmSales') }}</div>
                            <div class="header_button material-icons" id="tMallSaleSort"
                                @click="sortTableList('tMallSale')">
                                south
                            </div>
                        </div>
                    </th>
                    <th class="w120">
                        <div class="header_wrapper">
                            <div class="header_lable">{{ $t('countSales') }}</div>
                            <div class="header_button material-icons" id="allSaleSort"
                                @click="sortTableList('allSale')">
                                south
                            </div>
                        </div>
                    </th>
                    <th class="w150">
                        <div class="header_wrapper">
                            <div class="header_lable">{{ $t('jdDataDays') }}</div>
                            <div class="header_button material-icons">help_outline</div>
                            <div class="help_frame_default_size help_content" style="height: 100px;">
                                <div class="title">{{ $t('jdDataDays') }}</div>
                                <div class="desc">
                                    <div class="content">
                                        {{ $t('jdDataDaysDesc') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </th>
                    <th class="w150">
                        <div class="header_wrapper">
                            <div class="header_lable">{{ $t('tmDataDays') }}</div>
                            <div class="header_button material-icons">help_outline</div>
                            <div class="help_frame_default_size help_content" style="height: 100px;right: 0;">
                                <div class="title">{{ $t('tmDataDays') }}</div>
                                <div class="desc">
                                    <div class="content">
                                        {{ $t('tmDataDaysDesc') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </th>
                    <!-- <th class="w15" v-if="showTableFieldKeys[8].isShow">
                        {{ $t('operate') }}
                    </th> -->
                </tr>
            </thead>
        </table>
    </div>
<div class="table_box" id="table_box" :style="top">
        <table class="table_box2" :style="tableBox2Width">
            <tbody>
                <template v-for="(value, index) in tableList" :key="index">
                    <tr :style="{background: (index % 2 == 0) ? '' : '#f2f2f2'}">
                        <td class="w40" :style="{background: value.isfocus ? '#FED5D5' : ''}">{{ index + 1 }}</td>
                        <td class="w120">
                            <div class="view_button" @click="$emit('openchart', value.deviceId, value.name, '')">
                                {{ $t('show') }}
                            </div>
                        </td>
                        <td class="w15" v-if="showTableFieldKeys[0].isShow">
                            {{ value.code ? value.code : "-" }}
                        </td>
                        <td class="w2" v-if="showTableFieldKeys[1].isShow">
                            {{ value.productName ? value.productName : "-" }}
                        </td>
                        <td class="w2" v-if="showTableFieldKeys[2].isShow">
                            {{ value.model ? value.model : "-" }}
                        </td>
                        <td class="w2" v-if="showTableFieldKeys[3].isShow">
                            <div class="header_wrapper">
                                <div class="header_label">
                                    {{ value.name }}
                                </div>
                                <div v-if="value.catId > 0" :id="'show_level2_button_' + index"
                                    class="header_button material-icons" @click="changeLevel2Show(index)">
                                    keyboard_arrow_down
                                </div>
                            </div>
                        </td>
                        <td class="w120" v-if="showTableFieldKeys[4].isShow">
                            {{ value.attribute ? value.attribute : "-" }}
                        </td>
                        <td class="w15">
                            {{ value.salesGrowthFactor }}
                        </td>
                        <td class="w15">{{ value.returnRate }}</td>
                        <td class="w15" v-if="showTableFieldKeys[5].isShow">{{ value.jdStorage }}</td>
                        <td class="w15" v-if="showTableFieldKeys[6].isShow">
                            {{ value.tMallStorage }}
                        </td>
                        <td class="w15" v-if="showTableFieldKeys[7].isShow">{{ value.u8Storage }}</td>
                        <td class="w15">{{ value.totalStorage }}</td>
                        <!-- <td class="w15"> -->
                            <!-- {{ value.storageSaleDay !== 1000000 ? value.storageSaleDay: $t('stockDayStatus')}} -->
                            <!-- {{ value.storageSaleDay }} -->
                        <!-- </td> -->
                        <td class="w15" v-if="value.storageSaleDay <= 5" style="color: #F81919;">
                            {{ value.storageSaleDay }}
                        </td>
                        <td class="w15" v-if="value.storageSaleDay > 5 && value.storageSaleDay <= 14" style="color: #FC8F3B;">
                            {{ value.storageSaleDay }}
                        </td>
                        <td class="w15" v-if="value.storageSaleDay > 14 && value.storageSaleDay <= 180" style="color: #04C746;">
                            {{ value.storageSaleDay }}
                        </td>
                        <td class="w15" v-if="value.storageSaleDay > 180 && value.storageSaleDay !== 1000000" style="color: #4060FF;">
                            {{ value.storageSaleDay }}
                        </td>
                        <td class="w15" v-if="value.storageSaleDay === 1000000" style="color: #04C746;">
                            {{ $t('stockDayStatus')}}
                        </td>
                        <td class="w120">{{ value.jdSale }}</td>
                        <td class="w120">{{ value.tMallSale }}</td>
                        <td class="w120">{{ value.allSale }}</td>
                        <td class="w150">{{ value.jdDataDay }}</td>
                        <td class="w150">{{ value.tMallDataDay }}</td>
                        <!-- <td class="w15" v-if="showTableFieldKeys[8].isShow">
                            <div v-if="value.isfocus"  class="view_unimportant_button" @click="$emit('setAsMainProduct', value.deviceId)">
                                {{ $t('setAsNotMainProduct') }}
                            </div>
                            <div v-else  class="view_important_button" @click="$emit('setAsMainProduct', value.deviceId)">
                                {{ $t('setAsMainProduct') }}
                            </div>
                        </td> -->
                    </tr>
                    <tr :class="'level2_table level2_table_' + index" v-for="(v, i) in value.deviceInfo" :key="i">
                        <td class="w40" :style="{background: value.isfocus ? '#FED5D5' : ''}"></td>
                        <td class="w120">
                            <div class="view_button" @click="$emit('openchart', [v.id], v.productName, v.attribute)">
                                {{ $t('show') }}
                            </div>
                        </td>
                        <td class="w15" v-if="showTableFieldKeys[0].isShow">
                            {{ v.code }}
                        </td>
                        <td class="w2" v-if="showTableFieldKeys[1].isShow">
                            {{ v.name }}
                        </td>
                        <td class="w2" v-if="showTableFieldKeys[2].isShow">
                            {{ v.model }}
                        </td>
                        <td class="w2" v-if="showTableFieldKeys[3].isShow">
                            {{ v.productName }}
                        </td>
                        <td class="w120" v-if="showTableFieldKeys[4].isShow">
                            {{ v.attribute }}
                        </td>
                        <td class="w15">{{ v.salesGrowthFactor }}</td>
                        <td class="w15">{{ v.returnRate }}</td>
                        <td class="w15" v-if="showTableFieldKeys[5].isShow">{{ v.jdStorage }}</td>
                        <td class="w15" v-if="showTableFieldKeys[6].isShow">{{ v.tMallStorage }}</td>
                        <td class="w15" v-if="showTableFieldKeys[7].isShow">{{ v.u8Storage }}</td>
                        <td class="w15">{{ v.totalStorage }}</td>
                        <!-- <td class="w15">{{ v.storageSaleDay }}</td> -->
                        <td class="w15" v-if="v.storageSaleDay <= 5" style="color: #F81919;">
                            {{ v.storageSaleDay }}
                        </td>
                        <td class="w15" v-if="v.storageSaleDay > 5 && v.storageSaleDay <= 14" style="color: #FC8F3B;">
                            {{ v.storageSaleDay }}
                        </td>
                        <td class="w15" v-if="v.storageSaleDay > 14 && v.storageSaleDay <= 180" style="color: #04C746;">
                            {{ v.storageSaleDay }}
                        </td>
                        <td class="w15" v-if="v.storageSaleDay > 180 && v.storageSaleDay !== 1000000" style="color: #4060FF;">
                            {{ v.storageSaleDay }}
                        </td>
                        <td class="w15" v-if="v.storageSaleDay === 1000000" style="color: #04C746;">
                            {{ $t('stockDayStatus')}}
                        </td>
                        <td class="w120">{{ v.jdSale }}</td>
                        <td class="w120">{{ v.tMallSale }}</td>
                        <td class="w120">{{ v.allSale }}</td>
                        <td class="w150">{{ value.jdDataDay }}</td>
                        <td class="w150">{{ value.tMallDataDay }}</td>
                        <!-- <td class="w15" v-if="showTableFieldKeys[8].isShow">
                            <div v-if="value.isfocus"  class="view_unimportant_button" @click="$emit('setAsMainProduct', [v.id])">
                                {{ $t('setAsNotMainProduct') }}
                            </div>
                            <div v-else  class="view_important_button" @click="$emit('setAsMainProduct', [v.id])">
                                {{ $t('setAsMainProduct') }}
                            </div>
                        </td> -->
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</div>